import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';

@Component({
  selector: 'app-store',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './store.html',
  styleUrls: ['./store.css']
})
export class Store implements OnInit {
  baseUrl = 'https://logs.proofile.com.ng/api';

  stores: any[] = [];
  stockItems: any[] = [];
  storeTransfers: any[] = [];
  staff: any[] = [];

  showTransferModal: boolean = false;
  showSuccessPopup: boolean = false;



  transfer: any = {
    from_store_id: '',
    to_store_id: '',
    stock_item_id: '',
    quantity: '',
    note: '',
    transferred_by: 1
  };

  availableQty: number | null = null;
  loading = false;
  searchTerm = '';
  startDate: string = '';
  endDate: string = '';
  feedbackMessage = '';
  feedbackType: 'success' | 'error' = 'success';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchStores();
    this.fetchStockItems();
    this.fetchTransfers();
    this.fetchStaff();
  }

  fetchStores(): void {
    this.loading = true;
    this.http.get<any[]>(`${this.baseUrl}/stores`).subscribe(data => {
      this.stores = data;
      this.loading = false;
    });
  }

  fetchStockItems(): void {
    this.loading = true;
    this.http.get<any[]>(`${this.baseUrl}/stock-items`).subscribe(data => {
      this.stockItems = data;
      this.loading = false;

      // Recalculate availableQty if a stock item is already selected
      if (this.transfer.stock_item_id) {
        this.watchSelectionChanges();
      }
    });
  }

  fetchTransfers(): void {
    this.loading = true;
    this.http.get<any[]>(`${this.baseUrl}/store-transfers`).subscribe(data => {
      this.storeTransfers = data;
      this.loading = false;
    });
  }

  fetchStaff(): void {
    this.http.get<any[]>(`${this.baseUrl}/users`).subscribe(data => {
      this.staff = data;
    });
  }

  watchSelectionChanges(): void {
    const selectedItem = this.stockItems.find(i => i.id === +this.transfer.stock_item_id);
    this.availableQty = selectedItem?.quantity ?? null;
  }

  getLastTransferredQuantity(itemId: number): number | null {
    const recent = [...this.storeTransfers].reverse().find(t => t.stock_item_id === itemId);
    return recent?.quantity ?? null;
  }

  sendProduct(): void {
  // Ensure numeric types
  this.transfer.stock_item_id = +this.transfer.stock_item_id;
  this.transfer.from_store_id = +this.transfer.from_store_id;
  this.transfer.to_store_id = +this.transfer.to_store_id;
  this.transfer.quantity = +this.transfer.quantity;

  console.log('Payload being sent:', this.transfer); // 👈 Add this

  if (this.transfer.from_store_id === this.transfer.to_store_id) {
    return this.showMessage('❌ Cannot send to the same store.', 'error');
  }

  if (this.availableQty !== null && this.transfer.quantity > this.availableQty) {
    return this.showMessage(`⚠ Only ${this.availableQty} units available.`, 'error');
  }

  this.loading = true;

  this.http.post(`${this.baseUrl}/store-transfers`, this.transfer).subscribe({
    next: () => {
  this.showSuccessPopup = true;
  setTimeout(() => {
    this.showSuccessPopup = false;
  }, 3000);

  this.resetForm();
  this.fetchTransfers();
  this.fetchStockItems();
  setTimeout(() => this.watchSelectionChanges(), 300);
  this.loading = false;
}
,
    error: (err) => {
      console.error('❌ Transfer error:', err); // 👈 Confirm the backend message
      this.showMessage('❌ Failed to send product.', 'error');
      this.loading = false;
    }
  });
}



  resetForm(): void {
    this.transfer = {
      from_store_id: '',
      to_store_id: '',
      stock_item_id: '',
      quantity: '',
      note: '',
      transferred_by: 1
    };
    this.availableQty = null;
  }

  getStoreName(id: number): string {
    const store = this.stores.find(s => s.id === id);
    return store ? store.name : 'N/A';
  }

  getItemName(id: number): string {
    const item = this.stockItems.find(i => i.id === id);
    return item ? item.name : 'N/A';
  }

  getStaffName(id: number): string {
    const user = this.staff.find(u => u.id === id);
    return user ? user.name : 'Unknown';
  }

  get filteredTransfers(): any[] {
  return this.storeTransfers.filter(t => {
    const item = this.getItemName(t.stock_item_id).toLowerCase();
    const from = this.getStoreName(t.from_store_id).toLowerCase();
    const to = this.getStoreName(t.to_store_id).toLowerCase();
    const note = (t.note || '').toLowerCase();
    const searchMatch = [item, from, to, note].some(s =>
      s.includes(this.searchTerm.toLowerCase())
    );

    // Use `transferred_at` instead of `created_at`
    const transferDate = new Date(t.transferred_at);

    const start = this.startDate ? new Date(this.startDate) : null;
    const end = this.endDate ? new Date(this.endDate) : null;

    // Adjust end date to include full day
    if (end) {
      end.setHours(23, 59, 59, 999);
    }

    const inDateRange =
      (!start || transferDate >= start) &&
      (!end || transferDate <= end);

    return searchMatch && inDateRange;
  });
}


  exportToCSV(): void {
    const headers = ['From', 'To', 'Item', 'Quantity', 'Note', 'By', 'Date'];
    const rows = this.filteredTransfers.map(t => [
      this.getStoreName(t.from_store_id),
      this.getStoreName(t.to_store_id),
      this.getItemName(t.stock_item_id),
      t.quantity,
      t.note || '',
      this.getStaffName(t.transferred_by),
      new Date(t.created_at).toLocaleString()
    ]);

    const csvContent = [headers, ...rows]
      .map(row => row.map(value => `"${value}"`).join(','))
      .join('\n');

    const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', `store_transfer_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  showMessage(msg: string, type: 'success' | 'error'): void {
    this.feedbackMessage = msg;
    this.feedbackType = type;
    setTimeout(() => (this.feedbackMessage = ''), 4000);
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  trackByTransferId(index: number, transfer: any): number {
    return transfer.id;
  }
}
